enum HTMLContainerStyle {
	// TODO: Add more HTML formatting styles when new rich translation use cases need them.
	Small,
}

export default HTMLContainerStyle;
